/* The "include optional" chip and the list it opens — the sign-off
 * context's one control (Ale ruling 2026-09-05, Tier-2).
 *
 * The chip states the figure and nothing else: "include optional · 3".
 * With nothing optional owed it does not render at all — a switch with
 * nothing behind it is chrome. ON, the demands are listed with a door to
 * the chase queue, so the officer can ask for them before he signs; the
 * SIGN-OFF ITSELF IS UNTOUCHED either way, and no count moves.
 */

import { Link } from 'react-router-dom'
import { useIncludeOptional } from './optionalEvidence'
import './optionalevidence.css'

/** One optional demand, named the way the Evidence tab names it. */
export interface OptionalDemand {
  key: string
  /** "M1" — the demand's code. */
  code: string
  /** "movement document" — what it asks for. */
  words: string
  /** The object it sits on. */
  object: string
}

export function OptionalChip({ n, testId = 'optional-toggle' }: { n: number; testId?: string }) {
  const [on, set] = useIncludeOptional()
  if (n <= 0) return null
  return (
    <button
      type="button"
      className={`opt-chip${on ? ' on' : ''}`}
      data-testid={testId}
      aria-pressed={on}
      onClick={() => set(!on)}
    >
      include optional <span className="opt-n mono">· {n}</span>
    </button>
  )
}

/** The listing half — only while the chip is ON. */
export function OptionalList({
  demands,
  fundId,
  testId = 'optional-list',
}: {
  demands: OptionalDemand[]
  fundId: string | null
  testId?: string
}) {
  const [on] = useIncludeOptional()
  if (!on || demands.length === 0) return null
  return (
    <div className="opt-list" data-testid={testId}>
      <div className="opt-lead">
        Recommended, not required — the sign-off does not wait on these.
      </div>
      {demands.map((d) => (
        <div className="opt-row" data-testid="optional-demand" data-code={d.code} key={d.key}>
          <span className="opt-code mono">{d.code}</span>
          <span className="opt-words">{d.words}</span>
          <span className="opt-obj">{d.object}</span>
        </div>
      ))}
      {fundId ? (
        <Link
          className="opt-door"
          to={`/v2/workbench/chase-request?fund=${encodeURIComponent(fundId)}`}
          data-testid="optional-request-door"
        >
          Request them ›
        </Link>
      ) : null}
    </div>
  )
}
